let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4emPQ")).then(() => parcelRequire('dJJB4'));